import Box from "@mui/material/Box";
import { Grid, Typography, Stack, Divider, Paper } from "@mui/material";
import React from "react";
import { isMobile } from "react-device-detect";

const NewCraftForm = ({ craftsData }) => {
  return (
    <>
      <Box
        sx={{
          background: "#fff",
          fontWeight: "bold",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 1.5,
          px: 3,
          width: isMobile ? "100%" : 300,
          borderRadius: "8px",
          border: "2px solid",
          borderColor: "primary.main",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "primary.main" }}>
          الحرف و الصناعات
        </Typography>
      </Box>
      <Paper
        elevation={1}
        sx={{ 
          p: 3, 
          borderRadius: "12px",
          border: "1px solid #e0e0e0"
        }}
      >
        <Grid spacing={3} container>
        <Grid item md={3} xs={12}>
          <Stack direction={"row"} gap={1}>
            <Typography sx={{ fontWeight: "bold" }}>
              {" "}
              الحرف و الصناعات :
            </Typography>
            <Typography>{craftsData?.craftName}</Typography>
          </Stack>
        </Grid>

        <Grid item md={3} xs={12}>
          <Stack direction={"row"} gap={1}>
            <Typography sx={{ fontWeight: "bold" }}>التصنيف :</Typography>
            <Typography>{craftsData?.craftClass} </Typography>
          </Stack>
        </Grid>
        <Grid item md={3} xs={12}>
          <Stack direction={"row"} gap={1}>
            <Typography sx={{ fontWeight: "bold" }}>الدرجة :</Typography>
            <Typography>{craftsData?.craftGrade} </Typography>
          </Stack>
        </Grid>
        <Grid item md={3} xs={12}>
          <Stack direction={"row"} gap={1}>
            <Typography sx={{ fontWeight: "bold" }}>الرسوم :</Typography>
            <Typography>
              {`${craftsData?.price} ${craftsData?.currency?.name}`}{" "}
            </Typography>
          </Stack>
        </Grid>
        <Grid item md={3} xs={12}>
          <Stack direction={"row"} gap={1}>
            <Typography sx={{ fontWeight: "bold" }}>اسم المؤجر :</Typography>
            <Typography>{craftsData?.renterName} </Typography>
          </Stack>
        </Grid>
        <Grid item md={3} xs={12}>
          <Stack direction={"row"} gap={1}>
            <Typography sx={{ fontWeight: "bold" }}>
              رقم وثيقة المؤجر :
            </Typography>
            <Typography>{craftsData?.renterDocument} </Typography>
          </Stack>
        </Grid>
        <Grid item md={3} xs={12}>
          <Stack direction={"row"} gap={1}>
            <Typography sx={{ fontWeight: "bold" }}>الاسم التجاري :</Typography>
            <Typography>{craftsData?.tradeName} </Typography>
          </Stack>
        </Grid>
        <Grid item md={3} xs={12}>
          <Stack direction={"row"} gap={1}>
            <Typography sx={{ fontWeight: "bold" }}>
              رقم الرخصة التجارية :
            </Typography>
            <Typography>{craftsData?.businessLicenseNo} </Typography>
          </Stack>
        </Grid>
        <Grid item md={12} xs={12}>
          <Stack direction={"row"} gap={1}>
            <Typography sx={{ fontWeight: "bold" }}>الملاحظات :</Typography>
            <Typography>{craftsData?.notes} </Typography>
          </Stack>
        </Grid>
      </Grid>
      </Paper>
      <Divider />
    </>
  );
};

export default NewCraftForm;
